import { z } from "zod";
import {
  SectionSpacingSchema,
  TextAlignSchema
} from "../../../../../zod/shared-schemas.mjs";
const CardSectionShopsItemSchema = z.object({
  name: z.string(),
  image: z.object({
    src: z.string(),
    width: z.string().optional(),
    height: z.string().optional(),
    alt: z.string()
  }),
  link: z.object({
    src: z.string().optional()
  }).optional()
});
const CardSectionShopsSchema = z.object({
  id: z.string().optional(),
  title: z.string().optional(),
  description: z.string().optional(),
  textAlign: TextAlignSchema.optional(),
  items: CardSectionShopsItemSchema.array()
}).merge(SectionSpacingSchema);
export default CardSectionShopsSchema;
